import { Injectable } from '@angular/core';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { UtilidadesCrudService } from '@appNeo/neoShared/services/utilidades/utilidades-crud.service';
import { HttpClient } from '@node_modules/@angular/common/http';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { catchError, forkJoin, map, Observable, of } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class TiposMenuService extends UtilidadesCrudService {

  constructor(
    http: HttpClient,
    public auxiliar: AuxiliarService,
  ) {
    super(
      http,
      auxiliar,
      'tiposMenu', 
      'tiposMenu', 
      'Tipos Menú',
      'Tipos Menús',
      [
      ]
    );
  }

  /************************************ 
  * Funciones apoyo                  *
  *************************************/
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    let peticion = {};
    const id = route.params?.id;   
    if (id) {
      peticion['entidad'] = this.get(id).pipe(
        catchError(err => of(null))
      )
    }
    if (Object.keys(peticion).length > 0) {
      return forkJoin(peticion);
    } else {
      of(true);
    }
  }

}


